import { render, staticRenderFns } from "./S201.vue?vue&type=template&id=8340dcc4&scoped=true"
import script from "./S201.vue?vue&type=script&lang=js"
export * from "./S201.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=8340dcc4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8340dcc4",
  null
  
)

export default component.exports